import React, { useState } from "react";
import svg41 from "../../../assets/svg/svg41.svg";
import svg10 from "../../../assets/svg/svg10.svg";
import svg125 from "../../../assets/svg/svg125.svg";
import svg126 from "../../../assets/svg/svg126.svg";
import svg127 from "../../../assets/svg/svg127.svg";
import { useNavigate } from "react-router-dom";
import ElectricityModal from "./electricity/modal/ElectricityModal";
import WaterModal from "./water/modal/WaterModal";
import AirtimeModal from "./airtime/modal/AirtimeModal";

function UtilityHero({ title, subtitle }) {
  const navigate = useNavigate();

  const handleLogin = async () => {
    window.location.href = "https://app.ndovupay.org/#/login";
  };

  const [openElec, setOpenElec] = useState(false);
  const handleOpenElec = () => {
    setOpenElec(true);
  };
  const handleCancelElec = () => {
    setOpenElec(false);
  };

  const [openWater, setOpenWater] = useState(false);
  const handleOpenWater = () => {
    setOpenWater(true);
  };
  const handleCancelWater = () => {
    setOpenWater(false);
  };

  const [openAirtime, setOpenAirtime] = useState(false);
  const handleOpenAirtime = () => {
    setOpenAirtime(true);
  };
  const handleCancelAirtime = () => {
    setOpenAirtime(false);
  };

  const items = [
    {
      svg: svg125,
      title: "Electricity",
      desc: "Tokens or pay your electricity bill",
      handleClick: handleOpenElec,
    },
    {
      svg: svg126,
      title: "Water & Sanitation",
      desc: "Never Miss a Drop.",
      handleClick: handleOpenWater,
    },
    {
      svg: svg127,
      title: "Airtime & Data",
      desc: "Top up airtime or data for any Kenyan network",
      handleClick: handleOpenAirtime,
    },
  ];
  return (
    <>
      <div className="bg-img-2 h-auto pt-[5rem]">
        <div className="lg:px-[5.69rem] px-3 lg:min-h-[33rem] min-h-auto">
          <div className="lg:mt-[5.12rem] mt-[1rem] flex lg:flex-row flex-col justify-between gap-[2rem] lg:gap-[3rem] font-lexendS">
            <div className="w-full lg:max-w-[45%]">
              <div className="text-[#252525] text-[1.75rem] md:text-[2.5rem] lg:text-[3rem] font-[500] leading-tight lg:leading-[3.375rem] max-w-full lg:max-w-[39.8125rem] w-full">
                {title}
              </div>

              <div className="text-[rgba(37,37,37,0.8)] mt-[.5rem] text-[1rem] md:text-[1.125rem] font-[400] leading-[1.625rem] max-w-full lg:max-w-[36.625rem] w-full">
                {subtitle}
              </div>

              <div className="lg:mt-[4rem] mt-[1rem]">
                <button
                  type="button"
                  className="cstm-btn-2 max-w-[12rem] w-full sm:w-auto"
                  onClick={handleLogin}
                >
                  Start Now <img src={svg10} alt="svg10" />
                </button>
              </div>

              <div className="mt-[7.32rem] items-center text-center justify-center lg:flex hidden">
                <img src={svg41} alt="svg41" className="max-w-full h-auto" />
              </div>
            </div>
            <div className="grid grid-cols-2 lg:py-0 py-[2rem] gap-x-6 gap-y-[3.12rem]">
              {items &&
                items?.map((item, index) => (
                  <div
                    key={index}
                    className="rounded-[1.875rem] bg-white shadow-[0_0_31px_0_rgba(0,0,0,0.05)] w-[12.191rem] h-[12.99431rem] flex flex-col items-center justify-center text-center p-6"
                  >
                    <img
                      src={item?.svg}
                      alt={item?.svg}
                      className="w-[10.15919rem] h-[10.15919rem]"
                    />
                    <span className="mt-[-3rem] text-[#000] text-[1.25rem] font-[500] leading-[1.75rem] mb-2">
                      {item?.title}
                    </span>
                    <span className="text-[#000] text-[.75rem] font-[400] leading-[1rem] mb-4">
                      {item?.desc}
                    </span>

                    <button
                      onClick={item?.handleClick}
                      type="button"
                      className="rounded-[624.9375rem] bg-[#1E191B] shadow-[0_0_0_1px_#CBD5E1] py-[.5rem] px-[1rem] flex gap-[.5rem] items-center text-white"
                    >
                      Pay <img src={svg10} alt="svg10" />
                    </button>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>

      <ElectricityModal
        isModalOpen={openElec}
        handleCancel={handleCancelElec}
      />

      <WaterModal isModalOpen={openWater} handleCancel={handleCancelWater} />

      <AirtimeModal
        isModalOpen={openAirtime}
        handleCancel={handleCancelAirtime}
      />
    </>
  );
}

export default UtilityHero;
